import {HttpParams} from '@angular/common/http';
import {JsonApiParams} from '@tisa-group/cdk/models';

export const objectToHttpParams = (obj?: JsonApiParams): HttpParams => {
  let params = new HttpParams();

  if (!obj) {
    return params;
  }

  const {filter, page, sort, fields} = obj;

  if (filter) {
    Object.keys(filter).forEach((key: string) => {
      const rule = filter[key].rule ? '_' + filter[key].rule : '';

      if (Array.isArray(filter[key].value)) {
        params = params.appendAll({[`filter[${key}${rule}][]`]: filter[key].value});
      } else {
        params = params.append(
          `filter[${key}${rule}]`,
          filter[key].value as string | number | boolean,
        );
      }
    });
  }

  if (page) {
    params = params.append('page[number]', page.number);
    params = params.append('page[size]', page.size);
  }

  if (sort) {
    params = params.append('sort', sort.join(','));
  }

  if (fields) {
    Object.keys(fields).forEach((key: string) => {
      params = params.append(`fields[${key}]`, fields[key].join(','));
    });
  }

  Object.keys(obj)
    .filter(key => !['filter', 'page', 'sort', 'fields'].includes(key))
    .forEach((key: string) => {
      params = params.append(key, obj[key] as string | number | boolean);
    });

  return params;
};
